export type Section = 'home' | 'about' | 'faq' | 'projects' | 'contact';

/**
 * Unprefixed URL of each shell section. The 'about' section shows the
 * services, so its URL is /services (old /about links 301 there, see
 * firebase.json).
 */
export const SECTION_PATHS: Record<Section, string> = {
  home: '/',
  projects: '/projects',
  about: '/services',
  faq: '/faq',
  contact: '/contact',
};

/** Section for an unprefixed shell path; 'home' for anything else. */
export function sectionForPath(path: string): Section {
  const hit = (Object.keys(SECTION_PATHS) as Section[]).find((s) => SECTION_PATHS[s] === path);
  return hit ?? 'home';
}

export function slugToSection(slug?: string): Section {
  switch (slug) {
    case 'about-us': return 'about';
    case 'projects-and-partners': return 'projects';
    case 'contact-us': return 'contact';
    case 'faq': return 'faq';
    default: return 'home';
  }
}

export function sectionToSlug(section: Section): string {
  switch (section) {
    case 'about': return 'about-us';
    case 'faq': return 'faq';
    case 'projects': return 'projects-and-partners';
    case 'contact': return 'contact-us';
    default: return '';
  }
}
